/*
 * Facebook Auth
 * Facebook Javscript SDK v2.3
 * @author: Elton Jain
 *
 * Methods
 * - doLogin()
 * - doLogout()
 * - checkLoginState()
 */
define('modules/auth/facebook',['jquery', 'Config', 'UI', 'History'], function($, Config, UI, History) {
    'use strict';
    var APP_ID = Config.get('FB_APP_ID'),
        // APP_ID = '1677574999137048', // Live
        // APP_ID_LOCAL = '1573448199609456', // Local test app
        FB_SDK_VERSION = 'v2.9',
        SDKLOADED = false,
        APP_SCOPE = 'public_profile,email,user_birthday,user_relationships' + ',user_hometown,user_location,user_work_history,read_custom_friendlists,user_friends',
        langs = Config.get('lang');

    var Facebook = {
        loginState: null, // Stores the Facebook Login state/response
        loginOptions: {}, // Params passed for login
        triggerLogin: false, // If to initiate login after SDk
        redirect_url: null,
        extraData: {},
        fbToken: '', // Stores Facebook Token
        /*
         * Initialization
         */
        loadSDK: function (callback) {
            var base = this;
            window.fbAsyncInit = function() {
                FB.init({
                    appId: APP_ID,
                    cookie: true, // enable cookies to allow the server to access 
                    xfbml: true,
                    version: FB_SDK_VERSION
                });
                SDKLOADED = true;
                base.checkLoginState();
            };

            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        },

        init: function() {
            if(!SDKLOADED || !FB) {
                this.loadSDK();
            }
        },

        /*
         * Log into facebook api
         * If already login, just return login state
         */
        doLogin: function(options) {
            var base = this;

            base.loginOptions = options;

            if (base.loginOptions.redirect_url) {
                base.redirect_url = options.redirect_url;
            }

            base.extraData = $.extend(base.extraData, options);

            // Login Button Clicked Mixpanel Event
            if(base.extraData.type !== 'find') {
                require(['Mixpanel'], function(MixPanel) {

                    MixPanel.hit('login_click', {
                        login_type: 'FB',
                        trigger_source: base.extraData.trigger_source,
                    });
                });    
            } else {
                if(base.fbToken) {
                    UI.$b.addClass('loading');
                    base.renderFbFriends();
                    return;
                }
            }
            

            base.doFBLogin();
        },

        /*
         * Logout facebook
         */
        doLogout: function(callback) {
            if (this.loginState && this.loginState.status === 'connected') {
                FB.logout(function(response) {
                    if (callback) {
                        callback();
                    }
                });
            }
            this.loginState = {};
        },
        /*
         * Generate token after user grants access
         */
        generateToken: function(callback) {
            var base = this;
            if(!window.FB) {
                UI.$b.addClass('loading');
                setTimeout(function() {
                    base.generateToken(callback);
                }, 500);
                return false;
            }
            FB.login(function(response) {
                base.loginState = response;
                if (response.status === 'connected') {
                    base.postLogin(base.loginOptions);
                    if (callback) {
                        callback();
                    }
                } else {
                    UI.$b.removeClass('loading');
                    require(['Toastr'], function (Toastr) {
                        new Toastr({
                            'message': 'Unable to login with facebook. Please try again.'
                        });
                    });
                }
            }, {
                scope: APP_SCOPE
            });
        },

        doFBLogin: function(callback) {
            var base = this;
            if (base.loginState && base.loginState.status === 'connected') {
                base.postLogin(base.loginOptions);
                if (callback) {
                    callback();
                }
            } else {
                base.generateToken(callback);
            }
        },
        /*
         * Check Login status
         * @returns status (connected, not_authorized)
         */
        checkLoginState: function() {
            var base = this;
            if (typeof(FB) === 'undefined') {
                base.loadSDK();
            }
            // This function is called when someone finishes with the Login
            // Button.  See the onlogin handler attached to it in the sample
            // code below.
            FB.getLoginStatus(function(response) {
                base.statusChangeCallback(response);
            });
        },
        /*
         * Trigger when Facebook Login state is changed
         */
        statusChangeCallback: function(response) {
            var base = this;
            // This is called with the results from from FB.getLoginStatus().
            base.loginState = response;
            // The response object is returned with a status field that lets the
            // app know the current login status of the person.
            // Full docs on the response object can be found in the documentation
            // for FB.getLoginStatus().
            if (response.status === 'connected') {
                // Logged into your app and Facebook.
            } else if (response.status === 'not_authorized') {
                // The person is logged into Facebook, but not your app.
            } else {
                // The person is not logged into Facebook
            }
            if (base.triggerLogin === true) {
                base.doFBLogin();
            }
        },

        /*
         * renderFbFriends function fetches your facebook friends and renders them
         */
        
        renderFbFriends: function() {
            var base = this,
                ulContainerId = 'fbFriendsList',
                parentContainerId = 'fbFriendsContainer';

            require(['JSTemplate','User'], function(template, User) {
                var url = '/ajax/friends/fb',
                    data = {
                        fbToken: base.fbToken
                    };
                    User.init();
                $.post(url,data,function(response) {

                var html = template('tplUserListContainer',{
                    parentContainerId: parentContainerId,
                    ulContainerId: ulContainerId
                }),
                user_list = template('tplUserInvite',{
                    data: response.response.friends,
                    props: {
                        type: 'fbFriends',
                        langs: langs
                    }
                });

                UI.$b.append(html);

                $('#'+ ulContainerId).html(user_list);

                UI.$b.removeClass('loading');

                History.pushState({
                    url: window.location.pathname + '',
                    popupId: parentContainerId
                });

                UI.noscroll();

                });
                    
            });
            
        },
        
        /*
         * Fetch and update data after FB Auth Login or Sign up
         */
        postLogin: function(options) {
            var base = this,
                user = {};

            UI.$b.addClass('loading');

            function reloadPostLogin (response) {
                if (base.redirect_url) {
                    window.location.href = base.redirect_url;
                } else if (response.redirect_url) {
                    window.location.href = response.redirect_url;
                } else {
                    window.location.reload();
                }
            }

            FB.api('/me', {
                fields: 'last_name, first_name, gender, email, birthday, hometown, location, timezone, locale, relationship_status, id'
            }, function(response) {

                base.fbToken = FB.getAuthResponse().accessToken;

                if(base.extraData.type == 'find') {
                    base.renderFbFriends();
                    return;
                }
                var hometown, loc;

                if(response.error && response.error.code === 190) {
                    base.generateToken();
                    return;
                }

                if (response.hometown) {
                    hometown = response.hometown.name;
                } else {
                    hometown = '';
                }
                if (response.location) {
                    loc = response.location.name;
                } else {
                    loc = '';
                }

                if(!(response.id && response.email)) {
                    require(['Auth'], function (Auth) {
                        UI.$b.removeClass('loading');
                        $('.popup-login').removeClass('popup-default').addClass('popup-fb-account');
                        Auth.showLoginPopup(true, {
                            source: 'FB id and email absent',
                            callback: function() {
                                $('.popup-login').removeClass('popup-fb-account').addClass('popup-default');
                            }
                        });
                    });
                    return;
                }
                
                user = {
                    auth_type: 'facebook',
                    id: response.id,
                    image: 'http://graph.facebook.com/' + response.id + '/picture?type=large',
                    fname: response.first_name,
                    lname: response.last_name,
                    name: response.first_name + ' ' + response.last_name,
                    gender: response.gender,
                    email: response.email,
                    birthdate: response.birthday,
                    hometown: hometown,
                    location: loc,
                    timezone: response.timezone,
                    // work: response.work,
                    locale: response.locale,
                    marital_status: base.convertRelationshipStatus(response.relationship_status)
                };

                user.fbToken = base.fbToken;
                
                user = $.extend(user, base.loginOptions);
                // Send login info
                $.post('/ajax/user/login_fb', user, function(response) {
                    var mixpanelData = {},
                        mixpanelApi = 'login';

                    if (response.status === true) {

                        if(!user.email) {
                            user.email = user.id + '@mparenttown.com';
                        }


                        // If mixpanel is late
                        setTimeout(function () {
                            reloadPostLogin(response);
                        }, 5000);

                        try {
                        
                            if(response.response) {
                                mixpanelData = {
                                    firstname: user.fname || '',
                                    lastname: user.lname || '',
                                    created_at: response.response.created_at,
                                    email: user.email,
                                    gender: user.gender || '',
                                    // 'locale' : locale,
                                    timezone: user.timezone || '',
                                    birthday: user.birthday || '',
                                    user_id: response.response.id
                                };
                            }
                            if (response.response && response.response.is_new === true) {
                                mixpanelApi = 'signup';
                            }

                            mixpanelData.login_type = 'FB';
                            mixpanelData.trigger_source = base.extraData.trigger_source;

                            // Time limit 2sec
                            require(['Mixpanel'], function(MixPanel) {
                                MixPanel.hit(mixpanelApi, mixpanelData, function() {
                                    reloadPostLogin(response);
                                });
                            });
                        } catch (e) {
                            require(['Toastr'], function (Toastr) {
                                new Toastr({
                                    'message': e.message
                                });
                            });
                            reloadPostLogin(response);
                        }

                        if(window.location.hash !== '') {
                            History.popState();
                        }

                    } else if (response.status === false) {
                        UI.$b.removeClass('loading');
                        if (response.redirect_url) {
                            window.location.href = response.redirect_url;
                        } else {
                            alert(response.message);
                        }
                    }
                });
            });
        },
        /*
         * Format relationship status
         */
        convertRelationshipStatus: function(str) {
            if (!str) {
                return null;
            }
            str = str.toLowerCase();
            if (str.indexOf('single')) {
                return 'single';
            } else if (str.indexOf('open relationship')) {
                return 'open_relationship';
            } else if (str.indexOf('in a relationship')) {
                return 'in_relationship';
            } else if (str.indexOf('married')) {
                return 'married';
            } else if (str.indexOf('engaged')) {
                return 'engaged';
            } else if (str.indexOf('separated')) {
                return 'separated';
            } else if (str.indexOf('divorced')) {
                return 'divorced';
            } else if (str.indexOf('widowed')) {
                return 'widowed';
            } else if (str.indexOf('complicated')) {
                return 'complicated';
            }
            return null;
        }
    };

    return Facebook;
});
